import { ReportConfig, AppSlices, ReportContext } from 'api/Reports';
import { SelectOption } from 'koddi-components/Select';
import {
    ReduxAction,
    ReduxActionWithData,
    ReduxActionWithPayload,
} from 'types';
import { DatePickerPresetDateRange } from 'koddi-components/DateRangePicker/DateRangePicker.types';
import { ReportFilter } from 'koddi/types';
import { Currency } from 'api/Admin/Currency';

export enum FiltersAction {
    GET_DATE_RANGE_FILTER = 'app/filters/GET_DATE_RANGE_FILTER',
    UPDATE_DATE_RANGE_FILTER = 'app/filter/UPDATE_DATE_RANGE_FILTER',
    UPDATE_APP_SLICES = 'app/filter/UPDATE_APP_SLICES',
    UPDATE_APP_FILTER_SLICES = 'app/filters/UPDATE_APP_FILTER_SlICES',
    GET_REPORT_CONFIG = 'app/filters/GET_REPORT_CONFIG',
    GET_REPORT_CONFIG_SUCCESS = 'app/filters/GET_REPORT_CONFIG_SUCCESS',
    GET_REPORT_CONFIG_ERROR = 'app/filters/GET_REPORT_CONFIG_ERROR',
    UPDATE_REPORT_CONFIG = 'app/filters/UPDATE_REPORT_CONFIG',
    DELETE_DATE_RANGE_FILTER = 'app/filters/DELETE_DATE_RANGE_FILTER',
    UPDATE_GRAPH_METRIC = 'app/filters/UPDATE_GRAPH_METRIC',
    UPDATE_FILTER_DISPLAY_ORDER = 'app/filters/UPDATE_FILTER_DISPLAY_ORDER',
    SET_FILTER_ERROR = 'app/filters/SET_FILTER_ERROR',
}

export type UpdateDateRangeFilterAction = ReduxActionWithPayload<
    FiltersAction.UPDATE_DATE_RANGE_FILTER,
    { dateRange: DateRangeFilter }
>;

export type UpdateGraphMetricAction = ReduxActionWithPayload<
    FiltersAction.UPDATE_GRAPH_METRIC,
    { metric: SelectOption }
>;

export type UpdateAppSlicesAction = ReduxActionWithPayload<
    FiltersAction.UPDATE_APP_SLICES,
    { context: ReportContext; slices: AppSlices }
>;

export type UpdateAppFilterSlicesAction = ReduxActionWithPayload<
    FiltersAction.UPDATE_APP_FILTER_SLICES,
    { context: ReportContext; filters: ReportFilter[] }
>;

export type GetReportConfigAction = ReduxActionWithPayload<
    FiltersAction.GET_REPORT_CONFIG,
    {
        memberGroupId: number;
    }
>;

export type GetReportConfigSuccessAction = ReduxActionWithData<
    FiltersAction.GET_REPORT_CONFIG_SUCCESS,
    ReportConfig
>;

export type UpdateReportConfigAction = ReduxActionWithPayload<
    FiltersAction.UPDATE_REPORT_CONFIG,
    { reportConfig: ReportConfig }
>;

export type DeleteDateRangeFilterAction = ReduxAction<
    FiltersAction.DELETE_DATE_RANGE_FILTER
>;

export type GetReportConfigError = ReduxAction<
    FiltersAction.GET_REPORT_CONFIG_ERROR
>;

export type UpdateFilterDisplayOrder = ReduxActionWithPayload<
    FiltersAction.UPDATE_FILTER_DISPLAY_ORDER,
    { context: ReportContext; order: string[] }
>;
export type SetFilterError = ReduxActionWithPayload<
    FiltersAction.SET_FILTER_ERROR,
    { error: boolean }
>;

export type FiltersActions =
    | UpdateDateRangeFilterAction
    | DeleteDateRangeFilterAction
    | UpdateAppSlicesAction
    | UpdateReportConfigAction
    | UpdateGraphMetricAction
    | GetReportConfigSuccessAction
    | GetReportConfigError
    | GetReportConfigAction
    | UpdateAppFilterSlicesAction
    | UpdateFilterDisplayOrder
    | SetFilterError;

export type DateRangeFilter = {
    startDate: Date;
    endDate: Date;
    buttonLabel?: DatePickerPresetDateRange | null;
};

export type AppFiltersState = {
    dateRange: DateRangeFilter;
    slices: {
        [key: string]: AppSlices;
    };
    filterDisplayOrder: {
        [key: string]: string[];
    };
    reportConfig: ReportConfig | null;
    reportConfigError: boolean;
    graphMetric: SelectOption;
    currency: SelectOption<Currency> | null;
    filterError: boolean;
};
